import { Sidebar } from 'primeng/sidebar';

const maskClickListener = Sidebar.prototype.maskClickListener;
Sidebar.prototype.maskClickListener = function (this: Sidebar, event: MouseEvent) {
  if (event.target !== event.currentTarget) return;
  maskClickListener.call(this, event);
};
